import { get, post } from '@/api'

const SEARCH_OLS = 'vocabularies/ontologyterms/search-ols/'
const IMPORT_TERM = 'vocabularies/ontologyterms/import-term/'

/**
 * Search the OLS proxy endpoint. Single source for the endpoint path and
 * response shape so callers don't each re-extract `data.terms`.
 *
 * @param {Object} params - Query params. `q` is required; optional `id`
 *   (ontology UUID), `code` (ontology code), `page`, `size`, `exact`.
 * @returns {Promise<{terms: Array, totalElements: number}>}
 */
export async function searchOlsTerms(params) {
  const { status, data } = await get(SEARCH_OLS, { params })
  if (status !== 200) return { terms: [], totalElements: 0 }
  return { terms: data.terms || [], totalElements: data.total_elements || 0 }
}

/**
 * Import (link) an OLS term into a local ontology. Single source for the
 * import-term endpoint and its payload shape.
 *
 * @param {Object} payload - { ontology_id, term_iri, local_term_id, overwrite? }
 * @returns {Promise} the raw axios response (caller checks status)
 */
export function importOntologyTerm(payload) {
  // cancellable: false — navigating away cancels pending requests, and a
  // cancelled request resolves to a promise that never settles, which would
  // strand a batch import mid-loop. A write that has left the browser should
  // run to completion either way.
  return post(IMPORT_TERM, { data: payload, cancellable: false })
}
